import styled from 'styled-components';

export const SliderRating = styled.div.attrs({
  className: 'swiper-no-swiping'
})``;
